import { defineComponent as _defineComponent } from 'vue'
import { Device } from '@/models/device';
import { isEmpty, isNil } from '@/utils/misc';
import { Shift } from '@/models/shift';
import { Customer } from '@/models/tenant';
import TimeZoneIndicator from '@/components/TimeZoneIndicator.vue';
import { useI18n } from '@/composables/i18n';


/**
 * Shows information about selected element in page filters allowing multiple
 * selection and other useful context information.
 *
 * Props:
 * - selectedEquipment: List of selected devices. When the list is empty, it's
 *   interpreted as if all the devices where selected (if not filtering, show
 *   all).
 * - customer: Current customer. When set the customer name is shown.
 * - timeZone: IANA time zone name. Shows the time zone name and its current
 *   time when set.
 * - selectedShifts: List of selected shifts. When the list is empty, it's
 *   interpreted as if no shift were selected. This differs from
 *   `selectedEquipment` because in this case, selecting all shifts doesn't
 *   include the case in which a device isn't assigned to any turn.
 * - showShifts: Enables showing selected shifts when set to `true`.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MultipleSelectionFiltersHeader',
  props: {
    selectedEquipment: null,
    customer: null,
    timeZone: null,
    selectedShifts: null,
    showShifts: { type: Boolean, default: true }
  },
  setup(__props: any) {



const { t } = useI18n();

return { __sfc: true,t, isEmpty, isNil, TimeZoneIndicator }
}

})